module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_3009.4921c081.png";